import { Check, X, ShieldCheck } from "lucide-react";

export default function AdminAccreditationTab({ pendingAccred, onApprove, onReject }) {
  return (
    <div className="zc-card overflow-hidden overflow-x-auto mt-4" data-testid="admin-pending-accreditation">
      <div className="px-4 sm:px-6 py-3 border-b border-[var(--zc-border)] eyebrow">Curaçao investor attestations</div>
      {pendingAccred.length === 0 && <div className="px-4 sm:px-6 py-10 text-center text-[var(--zc-text-3)] text-sm">No pending attestations.</div>}
      {pendingAccred.map((row) => {
        const u = row.user || {};
        return (
          <div key={row.user_id} className="flex flex-col gap-3 sm:grid sm:grid-cols-[40px,1fr,auto] sm:items-start px-4 sm:px-6 py-4 border-b border-[var(--zc-border)] last:border-0">
            <div className="w-10 h-10 rounded-full grid place-items-center shrink-0" style={{ background: "rgba(37,99,235,0.12)" }}>
              <ShieldCheck size={16} style={{ color: "var(--zc-secondary,#2563eb)" }} />
            </div>
            <div className="min-w-0">
              <div className="zc-title text-lg leading-tight">{u.name || "—"} <span className="text-[var(--zc-text-3)] text-xs">· {u.email || row.user_id}</span></div>
              <div className="text-xs text-[var(--zc-text-3)] mt-1">
                Curaçao eligible: <b>{row.curacao_eligible ? "Yes" : "No"}</b> · KYC: <b>{u.kyc_status || "—"}</b>
                {u.evm_wallet_address && <span className="block font-mono text-2xs mt-1 break-all">{u.evm_wallet_address}</span>}
              </div>
              <div className="zc-meta mt-1 font-mono">Submitted {row.submitted_at ? new Date(row.submitted_at).toLocaleString() : "—"}</div>
            </div>
            <div className="flex flex-wrap gap-2 shrink-0 zc-stack-actions">
              <button onClick={() => onApprove(row.user_id)} className="px-3 h-9 zc-btn-primary text-xs flex items-center gap-1" data-testid={`accred-approve-${row.user_id}`}>
                <Check size={12} /> Approve
              </button>
              <button onClick={() => onReject(row.user_id)} className="px-3 h-9 zc-btn-ghost text-xs flex items-center gap-1" data-testid={`accred-reject-${row.user_id}`}>
                <X size={12} /> Reject
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
